export default __webpack_public_path__ + "static/logo-495e33bf39fac2c07139dff260bfb604.png";